import apiBase from 'src/api/api-base';
import { endpoints } from 'src/config/endpoints';
import Yard from 'src/models/yard';

export const getAllYards = async (): Promise<Yard[]> =>
  new Promise((resolve, reject) => {
    apiBase.get(endpoints.yards.getAll).then((response) => {
      resolve(response.data as Yard[]);
    });
  });
export const getYard = async (id: number | string): Promise<Yard> =>
  new Promise((resolve, reject) => {
    apiBase.get(endpoints.yards.get(id)).then((response) => {
      resolve(response.data as Yard);
    });
  });
export const createYard = async (yard: Yard): Promise<Yard> =>
  new Promise((resolve, reject) => {
    apiBase.post(endpoints.yards.create, yard).then((response) => {
      resolve(response.data as Yard);
    });
  });
export const updateYard = async (yard: Yard): Promise<Yard> =>
  new Promise((resolve, reject) => {
    apiBase.put(endpoints.yards.update(yard.id), yard).then((response) => {
      resolve(response.data as Yard);
    });
  });
export const deleteYard = async (id: number | string): Promise<Yard> =>
  new Promise((resolve, reject) => {
    apiBase.delete(endpoints.yards.delete(id)).then((response) => {
      resolve(response.data as Yard);
    });
  });